import React, { useState } from "react";
import { SiteTheme } from "../../types/types";

interface RecipeSearchProps {
    siteTheme: SiteTheme;
    searchPageUrl: string;
}

const RecipeSearch: React.FC<RecipeSearchProps> = ({
    siteTheme,
    searchPageUrl,
}) => {
    const [query, setQuery] = useState("");

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            window.location.href = `${searchPageUrl}?q=${query}`;
        }
    };

    const getClearImageSource = () => {
        if (siteTheme === SiteTheme.GARANT)
            return "/static/images/garant/cross/cross-green-thin.svg";
        if (siteTheme === SiteTheme.ELDORADO)
            return "/static/images/eldorado/cross/cross-black-thin.svg";
    };

    return (
        <>
            <div className="recipe-search__input-wrapper">
                <a
                    aria-label="Sök recept (navigerar till sökresultat-sidan)"
                    className="recipe-search__search-icon"
                    // TODO GTM add data-gtm here?
                    href={`${searchPageUrl}?q=${query}`}
                    title="Sök recept (navigerar till sökresultat-sidan)"
                >
                    <i className="fa-xl fa-solid fa-magnifying-glass"></i>
                </a>
                <input
                    name="recipe-search"
                    className="recipe-search__input"
                    type="text"
                    placeholder="Sök recept"
                    autoComplete="off"
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                    value={query}
                />
                <button
                    aria-label="Rensa sökfältet"
                    className="recipe-search__clear"
                    onClick={() => setQuery("")}
                    title="Rensa sökfältet"
                >
                    <img
                        alt=""
                        height="24"
                        width="24"
                        src={getClearImageSource()}
                    />
                </button>
            </div>
        </>
    );
};

export default RecipeSearch;
